<template>
  <div class="w-full gap-2 h-full flex flex-col  md:bg-white pb-4">
    <div class="flex flex-col w-full h-full overflow-y-scroll gap-3">
      <span class=" md:bg-white px-2 font-semibold text-sm">התראות חדשות</span>
      <span
        v-if="notifications.filter(x => !x.viewedAt).length === 0"
        class="p-2 w-full text-center text-sm py-4"
      >אין התראות חדשות</span>
      <notification-row
        v-for="notification of notifications.filter(x => !x.viewedAt)"
        v-else
        :key="notification.id"
        :notification="notification"
      />
      <span class=" md:bg-white px-2 font-semibold text-sm">התראות שנקראו</span>
      <notification-row
        v-for="notification of notifications.filter(x => x.viewedAt)"
        :key="notification.id"
        :notification="notification"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

import NotificationRow from '@app/components/admin/components/NotificationRow.vue';
import { computed } from 'vue';
import type { IAdminAppNotification } from '@torim-app/types';
import { useAdminStore } from '@app/stores';

const adminStore = useAdminStore();
const notifications = computed<Array<IAdminAppNotification & { _id: string }>>(() => adminStore.notifications);
</script>

<style scoped lang="scss">

</style>
